import { HEALTH_SYSTEM_STATUSES } from '../../constants'

export const STATUS_TYPES_CLASSNAMES = {
  GRAY: 'status-default--gray',
  YELLOW: 'status-default--yellow',
  RED: 'status-default--red',
  GREEN: 'status-default--green',
  LIGHTBLUE: 'status-default--lightblue',
  DARKBLUE: 'status-default--darkblue',
  BLACK: 'status-default--black',
  DARKGRAY: 'status-default--darkgray',
  ORANGE: 'status-default--orange',
  LIGHTRED: 'status-default--light-red'
}

export const USER_STATUS_TYPES_TO_CLASSNAME = {
  Active: STATUS_TYPES_CLASSNAMES.GREEN,
  Invited: STATUS_TYPES_CLASSNAMES.YELLOW,
  Archived: STATUS_TYPES_CLASSNAMES.LIGHTRED,
  Pending: STATUS_TYPES_CLASSNAMES.GRAY
}
export const TRIAL_APPROVAL_TYPES_TO_CLASSNAME = {
  approved: STATUS_TYPES_CLASSNAMES.GREEN,
  'no response': STATUS_TYPES_CLASSNAMES.GRAY,
  rejected: STATUS_TYPES_CLASSNAMES.LIGHTRED
}
export const TRIAL_APPROVAL_LABEL = {
  approved: 'Approved',
  'no response': 'No response',
  rejected: 'Rejected'
}

export const FINANCIAL_STATUS_TYPES_TO_CLASSNAME = {
  waiting_for_response: STATUS_TYPES_CLASSNAMES.LIGHTBLUE,
  payment_in_progress: STATUS_TYPES_CLASSNAMES.GRAY,
  declined: STATUS_TYPES_CLASSNAMES.LIGHTRED,
  payment_failed: STATUS_TYPES_CLASSNAMES.RED,
  disputed: STATUS_TYPES_CLASSNAMES.LIGHTRED,
  paid: STATUS_TYPES_CLASSNAMES.GREEN,
  partially_paid: STATUS_TYPES_CLASSNAMES.YELLOW,
  past_due: STATUS_TYPES_CLASSNAMES.ORANGE
}

export const CONTARCT_STATUS_TYPES_TO_CLASSNAME = {
  active: STATUS_TYPES_CLASSNAMES.GREEN,
  out_for_signature: STATUS_TYPES_CLASSNAMES.YELLOW,
  redlining: STATUS_TYPES_CLASSNAMES.GRAY,
  terminated: STATUS_TYPES_CLASSNAMES.LIGHTRED,
  declined: STATUS_TYPES_CLASSNAMES.LIGHTRED,
  contracting: STATUS_TYPES_CLASSNAMES.GRAY,
  pending_for_start: STATUS_TYPES_CLASSNAMES.LIGHTBLUE,
  expired: STATUS_TYPES_CLASSNAMES.RED,
  upload_in_progress: STATUS_TYPES_CLASSNAMES.GRAY
}

export const HOSPITAL_STATUS_TO_CLASSNAME = {
  Active: STATUS_TYPES_CLASSNAMES.GREEN,
  Archived: STATUS_TYPES_CLASSNAMES.LIGHTRED
}
export const HOSPITAL_STATUS_TO_STATUS = {
  active: 'Active',
  archived: 'Archived'
}

export const OPPORTUNITY_ANALYSIS_STATUSES_TO_CLASSNAME = {
  in_review: STATUS_TYPES_CLASSNAMES.GRAY,
  accepted: STATUS_TYPES_CLASSNAMES.GREEN,
  terminated: STATUS_TYPES_CLASSNAMES.LIGHTRED
}

export const CONTARCT_PIPELINES_STATUS_TYPES_TO_CLASSNAME = {
  active: STATUS_TYPES_CLASSNAMES.GREEN,
  future: STATUS_TYPES_CLASSNAMES.GRAY,
  in_process: STATUS_TYPES_CLASSNAMES.DARKBLUE
}

export const CONTRACT_PIPELINES_STATUS = {
  ACTIVE: 'active',
  IN_PROCESS: 'in_process',
  FUTURE: 'future'
} as const

export const CONTRACT_PIPELINES_STATUS_NAME = {
  [CONTRACT_PIPELINES_STATUS.ACTIVE]: 'Active',
  [CONTRACT_PIPELINES_STATUS.IN_PROCESS]: 'In-process',
  [CONTRACT_PIPELINES_STATUS.FUTURE]: 'Future'
} as const

export const HEALTH_SYSTEM_STATUSES_CLASSNAME = {
  [HEALTH_SYSTEM_STATUSES.ACTIVE]: STATUS_TYPES_CLASSNAMES.GREEN,
  [HEALTH_SYSTEM_STATUSES.ARCHIVED]: STATUS_TYPES_CLASSNAMES.LIGHTRED
} as const

export const DISPUTE_STATUSES_CLASSNAME = {
  excluded: STATUS_TYPES_CLASSNAMES.LIGHTBLUE,
  deferred: STATUS_TYPES_CLASSNAMES.LIGHTRED
}

export const MY_VENDOR_USER_STATUS = {
  ACTIVE: 'active',
  PENDING: 'pending',
  INACTIVE: 'inactive'
} as const

export const MY_VENDOR_USER_STATUS_TYPES_TO_CLASSNAME = {
  active: STATUS_TYPES_CLASSNAMES.GREEN,
  inactive: STATUS_TYPES_CLASSNAMES.DARKGRAY,
  pending: STATUS_TYPES_CLASSNAMES.GRAY
}

export const MY_VENDOR_USER_STATUS_NAME = {
  [MY_VENDOR_USER_STATUS.ACTIVE]: 'Active',
  [MY_VENDOR_USER_STATUS.PENDING]: 'Pending',
  [MY_VENDOR_USER_STATUS.INACTIVE]: 'Inactive'
} as const

export const DOCUMENT_REQUIRED_ACTION = {
  AWAITING_ACCEPTANCE: 'awaiting_acceptance',
  PENDING_SIGNATORY: 'pending_signatory',
  AWAITING_SIGNATURE: 'awaiting_signature'
} as const

export const DOCUMENT_REQUIRED_ACTION_NAME = {
  [DOCUMENT_REQUIRED_ACTION.AWAITING_ACCEPTANCE]: 'Acceptance',
  [DOCUMENT_REQUIRED_ACTION.PENDING_SIGNATORY]: 'Signatory',
  [DOCUMENT_REQUIRED_ACTION.AWAITING_SIGNATURE]: 'Signature'
} as const

export const DOCUMENT_REQUIRED_ACTION_TO_CLASSNAME = {
  [DOCUMENT_REQUIRED_ACTION.AWAITING_ACCEPTANCE]: 'document-status--acceptance',
  [DOCUMENT_REQUIRED_ACTION.PENDING_SIGNATORY]: 'document-status--signatory',
  [DOCUMENT_REQUIRED_ACTION.AWAITING_SIGNATURE]: 'document-status--signature'
} as const
